import Vue from 'vue';

Vue.filter('formatarDocumento', (valor) => {
  if (!valor) return '';
  valor = valor.replace(/\D/g, '');
  if (valor.length === 11) { // CPF
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } if (valor.length === 14) { // CNPJ
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  } if (valor.length <= 9) { // RG
    return valor.replace(/^(\d{1,2})(\d{3})(\d{3})(\w|\W)$/, '$1.$2.$3-$4');
  }
  return valor;
});
